import React, { useMemo } from 'react';
import './Charts.css';

export interface BarDataPoint {
  month: string;
  billable: number;
  unbillable: number;
  total: number;
}

interface BarChartProps {
  data: BarDataPoint[];
  height?: number;
}

export function BarChart({ data, height = 200 }: BarChartProps) {
  const maxVal = useMemo(() => Math.max(...data.map(d => d.total), 1), [data]);
  const barWidth = 26;
  const gap = 14;
  const chartWidth = data.length * (barWidth * 2 + gap + 8) + 50;

  return (
    <div className="bar-chart-wrapper">
      <div className="bar-chart-scroll">
        <svg width={Math.max(chartWidth, 380)} height={height + 40} className="bar-chart-svg">
          {[0, 0.25, 0.5, 0.75, 1].map((frac) => {
            const y = height - frac * (height - 30);
            return (
              <g key={frac}>
                <line x1={40} y1={y} x2={chartWidth} y2={y}
                  stroke="var(--border-primary)" strokeDasharray="4" opacity="0.4" />
                <text x={36} y={y + 4} textAnchor="end" className="bar-axis-label">
                  {Math.round(maxVal * frac)}
                </text>
              </g>
            );
          })}
          {data.map((d, i) => {
            const x = 50 + i * (barWidth * 2 + gap + 8);
            const billH = (d.billable / maxVal) * (height - 30);
            const unbillH = (d.unbillable / maxVal) * (height - 30);
            return (
              <g key={i}>
                <rect x={x} y={height - billH} width={barWidth} height={Math.max(billH, 0)}
                  rx={4} fill="#10b981" className="bar-rect">
                  <title>Billable: {d.billable.toLocaleString()} hrs</title>
                </rect>
                <rect x={x + barWidth + 3} y={height - unbillH} width={barWidth} height={Math.max(unbillH, 0)}
                  rx={4} fill="#f59e0b" className="bar-rect">
                  <title>Non-Billable: {d.unbillable.toLocaleString()} hrs</title>
                </rect>
                <text x={x + barWidth + 1} y={height + 18} textAnchor="middle" className="bar-month-label">
                  {d.month}
                </text>
              </g>
            );
          })}
        </svg>
      </div>
      <div className="bar-chart-legend">
        <span className="bar-legend-item"><span className="legend-dot" style={{ background: '#10b981' }} /> Billable</span>
        <span className="bar-legend-item"><span className="legend-dot" style={{ background: '#f59e0b' }} /> Non-Billable</span>
      </div>
    </div>
  );
}
